/**
 * @author silence
 * @desc:个人中心接口
 * */
import request from '@/utils/ajax';



export function createMerchant(data) {
  return request({
    url: '/pms/crm/createMerchant',
    method: 'post',
    data,
  });
}

// 修改商户信息
export function updateMerchant(data) {
  return request({
    url: '/pms/crm/updateMerchant',
    method: 'put',
    data,
  });
}

//新增商户产品关联关系
export function createMerProdRelation(data) {
  return request({
    url: '/pms/crm/createMerProdRelation',
    method: 'post',
    data,
  });
}

//编辑商户产品关联关系
export function updateMerProdRelation(data) {
  return request({
    url: '/pms/crm/updateMerProdRelation',
    method: 'put',
    data,
  });
}
// 全部商户列表接口
export function queryValidMerchants(data) {
  return request({
    url: '/pms/crm/allMerchant',
    method: 'get',
    params: data,
  });
}
